import { graphql, StaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import * as React from "react"

const query = graphql`
  query {
    allPeople(sort: { name: ASC }) {
      nodes {
        name
        linkedin
        function {
          de
          en
          nl
        }
        picture {
          childImageSharp {
            gatsbyImageData(
              width: 300
              placeholder: BLURRED
              formats: [AUTO, WEBP, AVIF]
              # focus on the faces
              transformOptions: { cropFocus: ATTENTION }
            )
          }
        }
      }
    }
  }
`

interface Person {
  name: string
  linkedin: string
  function: { [key: string]: string }
  picture: any
}

export interface PeopleGridProps {
  lang: string
}

const sortOrderFunctions = ["Voorzitter", "Secretaris", "Penningmeester"]

export class PeopleGrid extends React.Component<PeopleGridProps> {
  render() {
    return (
      <div>
        <StaticQuery
          query={query}
          render={data => {
            return (
              <div className="grid gap-6 grid-cols-1 xs:grid-cols-2 md:grid-cols-3 w-full max-w-2xl auto-cols-fr">
                {data.allPeople.nodes
                  .sort(
                    // sort by function nl
                    (a: Person, b: Person) => {
                      const aIndex = sortOrderFunctions.indexOf(a.function?.nl)
                      const bIndex = sortOrderFunctions.indexOf(b.function?.nl)
                      if (aIndex === -1) return 1
                      if (bIndex === -1) return -1
                      return aIndex - bIndex
                    }
                  )
                  .sort(
                    // sort by picture
                    (a: Person, b: Person) => {
                      if (
                        a.picture?.childImageSharp?.gatsbyImageData?.images?.fallback?.src?.includes(
                          "placeholder"
                        ) &&
                        !b.picture?.childImageSharp?.gatsbyImageData?.images?.fallback?.src?.includes(
                          "placeholder"
                        )
                      )
                        return 1
                      if (
                        !a.picture?.childImageSharp?.gatsbyImageData?.images?.fallback?.src?.includes(
                          "placeholder"
                        ) &&
                        b.picture?.childImageSharp?.gatsbyImageData?.images?.fallback?.src?.includes(
                          "placeholder"
                        )
                      )
                        return -1
                      return 0
                    }
                  )
                  .map((node: Person) => {
                    const picture =
                      node.picture === null ? null : getImage(node.picture)
                    return (
                      <a
                        href={`https://linkedin.com/in/${node.linkedin}`}
                        className="relative rounded-3xl overflow-hidden shadow-md col-span-1 aspect-square"
                      >
                        <div className="absolute bottom-0 left-0 z-10 p-4 pt-8 flex flex-col w-full bg-gradient-to-b from-transparent to-black text-white">
                          {node.function && (
                            <h4 className="text-sm">
                              {node.function[this.props.lang]}
                            </h4>
                          )}
                          <p className="text-lg font-semibold leading-tight text-white">
                            {node.name}
                          </p>
                        </div>
                        {picture ? (
                          <GatsbyImage
                            image={picture}
                            alt={node.name}
                            className="object-cover w-full h-full"
                          />
                        ) : null}
                      </a>
                    )
                  })}
                <div className="sm:col-span-3 bg-gray-100 shadow-sm rounded-xl text-primary p-6 flex flex-col gap-4 justify-center items-center">
                  {this.props.lang === "nl" && (
                    <>
                      <p className="text-2xl font-semibold">
                        Heb je je propedeuse op zak en lijkt het je wat om je
                        juridische kennis in de praktijk te brengen?
                      </p>
                      <p>
                        <a href="work" className="button">
                          Klik dan hier
                        </a>
                      </p>
                    </>
                  )}
                </div>
              </div>
            )
          }}
        />
      </div>
    )
  }
}
